<template>
  <div class="part">
    <div class="number">06</div>
    <join ></join>
  </div>
</template>

<script type="text/ecmascript-6">
import Join from './join'
export default {
  data() {
    return {

    }
  },
  components: {
    Join
  }
}
</script>

<style scoped lang="scss">
@import "../../common/common.scss";
.part{
  margin-top: 240px;
  position: relative;
  width: 1200px;
  margin: 240px auto 0;
  .number{
    font-size: 180px;
    color:$theme-color;
    opacity: 0.1;
    line-height: 1.0;
    position: absolute;
    top: 24px;
    left: -150px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/business/IndexPartSix.vue